<template>
  <div>
    <ColorPicker
      base="#000000"
      :color="selectedColor"
      @input="setColor($event, 'font_color')"
      ref="fontColorPicker"
    ></ColorPicker>

    <div :name="name" :id="name" ref="quill-input"></div>

    <div
      class="modal fade"
      ref="modal"
      tabindex="-1"
      aria-labelledby="button-setup-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ 'Button' | translate }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="">{{ 'URL' | translate }}</label>
              <input
                type="text"
                class="form-control"
                placeholder="https://your.link.here"
                v-model="url"
              />
            </div>

            <div class="mb-3">
              <label for="">{{ 'Style' | translate }}</label>
              <select name="" id="" v-model="btn_style" class="form-control">
                <option value="primary">{{ 'Blue' | translate }}</option>
                <option value="outline-primary">
                  {{ 'Blue' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="secondary">{{ 'Grey' | translate }}</option>
                <option value="outline-secondary">
                  {{ 'Grey' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="info">{{ 'Cyan' | translate }}</option>
                <option value="outline-info">
                  {{ 'Cyan' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="success">{{ 'Green' | translate }}</option>
                <option value="outline-success">
                  {{ 'Green' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="warning">{{ 'Yellow' | translate }}</option>
                <option value="outline-warning">
                  {{ 'Yellow' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="danger">{{ 'Red' | translate }}</option>
                <option value="outline-danger">
                  {{ 'Red' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="light">{{ 'Light' | translate }}</option>
                <option value="outline-light">
                  {{ 'Light' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="dark">{{ 'Dark' | translate }}</option>
                <option value="outline-dark">
                  {{ 'Dark' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="indigo">{{ 'Indigo' | translate }}</option>
                <option value="outline-indigo">
                  {{ 'Indigo' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="pink">{{ 'Pink' | translate }}</option>
                <option value="outline-pink">
                  {{ 'Pink' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="purple">{{ 'Purple' | translate }}</option>
                <option value="outline-purple">
                  {{ 'Purple' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="teal">{{ 'Teal' | translate }}</option>
                <option value="outline-teal">
                  {{ 'Teal' | translate }} ({{ 'outline' | translate }})
                </option>
                <option value="link">{{ 'Link' | translate }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="">{{ 'Size' | translate }}</label>
              <select name="" id="" v-model="btn_size" class="form-control">
                <option value="sm">{{ 'Small' | translate }}</option>
                <option value="">{{ 'Default' | translate }}</option>
                <option value="lg">{{ 'Large' | translate }}</option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {{ 'Cancel' | translate }}
            </button>
            <button type="button" class="btn btn-primary" @click="formatButton">
              {{ 'Ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ColorPicker from '~/app2/components/ColorPickerNoInput'

export default {
  components: {
    ColorPicker,
  },
  props: [
    'name',
    'displayName',
    'placeholder',
    'value',
    'editorBackground',
    'editorOverlay',
  ],
  data() {
    return {
      selectedColor: '#000000',
      quill: null,
      quillContents: null,
      html: null,
      url: null,
      btn_size: '',
      btn_style: 'primary',
      modalNode: null,
      modal: null,
    }
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {})
    this.quill = new Quill(this.$refs['quill-input'], {
      modules: {
        toolbar: [
          [
            { header: [1, 2, 3, 4, 5, 6, false] },
            { display: [1, 2, 3, 4, 5, 6, false] },
            { bolder: ['light', false, 'bold', 'bolder'] },
            { font: [] },
          ],
          [
            'italic',
            'underline',
            'strike',
            { color: 'custom-color' },
            { background: [] },
            { align: [false, 'right', 'center', 'justify'] },
          ],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'clean', 'button'],
        ],
      },
      theme: 'snow',
    })

    let toolbar = this.quill.getModule('toolbar')
    toolbar.addHandler('button', this.setupButton)

    toolbar.addHandler('color', this.customColors)
    
    this.quill.on('editor-change', _.debounce(this.editorChange, 200))
    this.quill.setContents(JSON.parse(this.value || '{}'))

    if (this.editorOverlay) {
      this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
    }
    if (this.editorBackground) {
      this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
    }
  },
  watch: {
    editorBackground() {
      if (this.editorBackground) {
        this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
        return
      }
      this.quill.container.style.cssText = `background: none;`
    },
    editorOverlay() {
      if (this.editorOverlay) {
        this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
      }
    },
  },
  methods: {
    setColor(color, element) {
      this.quill.format('color', color)
    },
    customColors(value) {
      if (value == 'custom-color') {
        // value = prompt('Enter Hex/RGB/RGBA')
        // this.selectedColor = this.quill.getFormat();
        this.$refs.fontColorPicker.setColor(
          _.get(this.quill.getFormat(), 'color', '#000000'),
        )
        return this.$refs.fontColorPicker.toggleModal()
      }
      this.setColor(value, 'font_color')
    },
    openModal() {
      document.body.appendChild(this.$refs.modal)
      this.modal.show()
    },
    closeModal() {
      this.modal.hide()
    },
    setupButton() {
      let format = this.quill.getFormat()
      let range = this.quill.getSelection()

      if (format['button']) {
        this.quill.format('button', false)
        return null
      }

      this.openModal()
    },
    formatButton() {
      if (this.url) {
        this.closeModal()

        this.quill.format('button', {
          url: this.url,
          data_size: this.btn_size,
          data_style: this.btn_style,
        })

        this.url = null
        this.btn_style = 'primary'
        this.btn_size = ''
      }
    },
    editorChange(eventName, ...args) {
      if (eventName === 'text-change' || eventName === 'selection-change') {
        this.$emit(
          'quillChanged',
          this.quill.root.innerHTML,
          JSON.stringify(this.quill.getContents()),
        )
      }
    },
  },
}
</script>
